import React, { useState, FC, useEffect } from "react";
import { Button } from "antd";
import { YHModal } from "@/components/YHModal";
import { PoTable } from "./poTable";
import { SoTable } from "./soTable";
import { StockTable } from "./stockTable";
import { useRecordGoodsModel } from "./recordGoodsModel";

type ISCMGoodsRecordType = "po" | "so" | "stock" | "";

export const GoodsRecordsModal = () => {
	const {
		goodsRecordModal: { visible, materialCode, materialName, code, inventoryQuantity }, setGoodsRecordModal
	} = useRecordGoodsModel();

	const [recordType, setRecordType] = useState<ISCMGoodsRecordType>("");

	const onCancel = () => {
		setGoodsRecordModal({
			visible: false,
			materialCode: "",
		});
	};

	useEffect(() => {
		setRecordType(visible ? "po" : "");
	}, [visible])

	const RecordDetails: FC<{ recordType: ISCMGoodsRecordType }> = ({ recordType }) => {
		switch (recordType) {
			case "po":
				return <PoTable />
			case "so":
				return <SoTable />
			case "stock":
				return <StockTable />
			default:
				return <></>
		}
	}

	const classname = (type: string) => {
		return 'tab-item ' + (recordType === type ? 'tab-active' : '')
	}

	return <YHModal
		visible={visible}
		onCancel={onCancel}
		title={<><span>商品编号:<span>{materialCode}</span></span><span className="ml-20">商品名称:<span>{materialName}</span></span></>}
		width={1300}
		bodyHeight={550}
	>
		<div style={{ margin: "0 0 10px 10px" }}>
			<Button
				// className={`${recordType === "po" ? "tab-buts-active" : ""}`}
				className={classname('po')}
				type="link"
				shape="round"
				onClick={() => setRecordType("po")}
			>采购历史</Button>
			<Button
				// className={`${recordType === "so" ? "tab-buts-active" : ""}`}
				className={classname('so')}
				type="link"
				shape="round"
				onClick={() => setRecordType("so")}
			>销售历史</Button>
			<Button
				// className={`mr-5 ${recordType === "stock" ? "tab-buts-active" : ""}`}
				className={classname('stock')}
				type="link"
				shape="round"
				onClick={() => setRecordType("stock")}
			>各门店库存</Button>
		</div >

		<RecordDetails recordType={recordType} />

	</YHModal>
}